import React, { useState} from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Upload, Button } from 'antd';


export default function GetUploadFile(
    {
        onSelect,  // Hook to really upload the file selected from the local machine
        buttonText='Upload file',
        disabled=false,
        ...props
    }) {

    const [status, setStatus] = useState('');
    const [fileList, setFileList] = useState([]);

    function beforeUpload(file){
        setStatus('Uploading...');

        // Note don't wait
        Promise.resolve(onSelect(file))
            .then(()=>{
                //message.success(file.name+' uploaded');
            })
            .catch(()=>{
                //message.error(file.name+' upload failed');
            })
            .finally(()=>{
                setStatus('');
                setFileList([]);
            });

        return false;  //Disable <Upload> file upload
    }

    return (
        <Upload {...{beforeUpload,fileList}} {...props}>
            <Button icon={<UploadOutlined />} type={'link'} disabled={disabled}>{buttonText}</Button>
            <br/>
            {status}
        </Upload>
    );
}